/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

import { cn } from '@/lib/utils';
import Icons from '../../../icons/icons';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { useLanguage } from '../../../providers/LanguageProvider';

interface EvalFeedbackProps {
  approved: boolean;
  disapproved: boolean;
  handleUserApproval: (event: React.MouseEvent<HTMLButtonElement>) => void;
  openFeedbackModal: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const EvalFeedback = ({ handleUserApproval, approved, disapproved, openFeedbackModal }: EvalFeedbackProps) => {
  const { messages } = useLanguage();
  const evaluationLang = (messages as any)?.Evaluation;

  return (
    <div className={cn(
      'absolute bottom-0 right-0 top-0',
      'flex items-center justify-center rounded-full bg-[#0A343C] px-1',
      'opacity-0 transition-opacity duration-150',
      'pointer-events-none group-hover:pointer-events-auto group-focus-within:pointer-events-auto',
      'group-hover:opacity-100 group-focus-within:opacity-100'
    )}>
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <span onClick={handleUserApproval} className="pointer-events-auto cursor-pointer hover:bg-[#257C9D3D] p-0.5 rounded-full">
                    {approved
                      ? Icons.LikeFeedbackFilledIcon('size-3.5')
                      : Icons.LikeFeedbackIcon('size-3.5')}
                    </span> 
                </TooltipTrigger>
                <TooltipContent side="bottom">
                    {evaluationLang?.approve}
                </TooltipContent>
             </Tooltip>

            <Tooltip>
            <TooltipTrigger asChild>
                <span onClick={openFeedbackModal} className="pointer-events-auto cursor-pointer hover:bg-[#257C9D3D] p-0.5 rounded-full">
                {disapproved
                      ? Icons.DislikeFeedbackFilledIcon('size-3.5')
                      : Icons.DislikeFeedbackIcon('size-3.5')}
                </span>
            </TooltipTrigger>
            <TooltipContent side="bottom">
                    {evaluationLang?.provide_feedback}
                </TooltipContent>
            </Tooltip>
      </TooltipProvider>     
    </div>
  );
};

export default EvalFeedback;
